const initialState = {
  qualityAssuranceList: {
    newQualityAssurance: false,
  },
};

export default initialState;
